import { createContext } from 'react';
export const PriceContext = /*#__PURE__*/createContext({
  size: 'lg'
});